import React, { useEffect, useState } from 'react';
import { useStyles } from "./DocumentViewer.style";
import DocumentViewerProperties from "./DocumentViewerProperties";
import { RestClient } from '../../util/RestClient';
import PageLoading from "../PageLoading/PageLoading";
import { useI18nContext } from "../../contexts/I18nContext";

const DocumentViewer: React.FC<DocumentViewerProperties> = ({ url }) => {
    const classes = useStyles();
    const i18n = useI18nContext();
    const [resource, setResource] = useState<string>("");
    const [type, setType] = useState<string>("");
    const [loading, setLoading] = useState<boolean>(true);

    const isMobile = /Mobi|Android/i.test(navigator.userAgent);
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

    useEffect(() => {
        setLoading(true);
        RestClient.download(url)
            .then((response) => {
                const blob = response.data?.data;
                setType(blob?.type || "");
                const objectUrl = window.URL.createObjectURL(blob);
                setResource(objectUrl);

                if (isMobile) {
                    if (isSafari) {
                        // Safari no abre blob: directo
                        const reader = new FileReader();
                        reader.onloadend = () => {
                            const a = document.createElement("a");
                            a.href = reader.result as string;
                            a.download = "document.pdf";
                            document.body.appendChild(a);
                            a.click();
                            document.body.removeChild(a);
                        };
                        reader.readAsDataURL(blob);
                    } else {
                        window.open(objectUrl, "_blank");
                    }
                }
            })
            .finally(() => {
                setLoading(false);
            });
    }, [url, isMobile, isSafari]);

    return (
        <div className={classes.document_viewer_container}>
            <PageLoading isLoading={loading} text={i18n.translate("DOWNLOADING_DOCUMENT")} />
            {!isMobile && resource && (
                <embed src={resource} type={type} width="100%" height="100%" />
            )}
        </div>
    );
}

export default DocumentViewer;
